/* ============================================================
   arthene — Über uns: Bühnenhöhe, Reveals, Porträt, Anfahrt, Wanderung

   Fünf Dinge stehen hier:
     1. die Höhe des ersten Bildes (--kopf-h, siehe unten)
     2. die Reveals: Absätze und Standort kommen beim Scrollen herein
     3. das Porträt, das neben „seinem" Absatz auftaucht
     4. die Anfahrt: die Kamerafahrt aus dem Gemälde auf das erste Bild
     5. die Wanderung: danach wird die Malfläche an den Porträtplatz
        getragen

   Punkt 2 und 3 setzen ausschließlich Klassen, die in
   arthene-ueber-uns.css beschrieben sind. Ohne JavaScript und bei
   „Bewegung reduzieren" steht die Seite vollständig sichtbar da.
   ============================================================ */

/* ------------------------------------------------------------
   1. Die Höhe des ersten Bildes

   Das erste Bild soll genau den freien Schirm unter der Kopfzeile
   füllen und nichts vom Text darunter anschneiden. Wie hoch die
   Kopfzeile ausfällt, hängt auf dieser Seite vom Kopf-Signet ab
   (siehe arthene-ueber-uns.css) und lässt sich im CSS nicht sauber
   nachrechnen. Hier wird sie gemessen und als --kopf-h an die Section
   gelegt — mehr macht diese Datei nicht.

   Ohne JavaScript greift der Vorgabewert im CSS: die Bühne ist dann
   ein paar Pixel zu hoch, sonst ändert sich nichts.
   ------------------------------------------------------------ */
(function () {
  'use strict';

  function messen() {
    var sec = document.querySelector('[data-arthene-rundgang]');
    if (!sec) return;

    var kopfzeile = document.querySelector('.masthead');
    if (!kopfzeile) return;

    /* Nur bei echter Änderung schreiben: eine Variable an der Section
       stellt den Stil aller Kinder in Frage, und resize kommt auf dem
       iPhone bei jedem Ein- und Ausfahren der Adressleiste. */
    var kopf = kopfzeile.offsetHeight + 'px';
    if (sec.style.getPropertyValue('--kopf-h') !== kopf) sec.style.setProperty('--kopf-h', kopf);

    /* Zweites Maß, nur für schmale Schirme: dort stehen Schriftzug und
       Staffelei untereinander, und die Bühne ist während der Anfahrt
       genau einen Schirm hoch. Was der Schriftzug belegt, bleibt der
       Staffelei nicht — sonst ragen ihre Beine aus der Bühne und werden
       abgeschnitten. Die Rechnung steht in arthene-ueber-uns.css. */
    var titel = sec.querySelector('.rundgang__title');
    if (titel) {
      var th = titel.offsetHeight + 'px';
      if (sec.style.getPropertyValue('--titel-h') !== th) sec.style.setProperty('--titel-h', th);
    }
  }

  var geplant = false;
  function anfordern() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(function () {
      geplant = false;
      messen();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', messen);
  } else {
    messen();
  }

  /* Die Leiste wächst und schrumpft mit der Fensterbreite (clamp), und
     Webfonts kommen nach — beides ändert ihre Höhe nachträglich. */
  window.addEventListener('resize', anfordern, { passive: true });
  /* Das Kopf-Signet ist ein Bild: vor seinem Laden ist die Leiste niedriger. */
  window.addEventListener('load', messen);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(messen);

  /* Theme-Editor: nach jedem Neuladen einer Section neu messen. */
  document.addEventListener('shopify:section:load', messen);
})();

/* ============================================================
   2. Scroll-Reveals und 3. das Porträt

   Reveals: jedes Element bekommt .rv (im CSS: ausgeblendet und ein
   Stück tiefer), beim Eintritt ins Bild .in — und kurz darauf sind
   beide Klassen wieder weg. Die Endlage ist der Normalzustand, und
   die lange Reveal-Transition soll danach nicht an Hover-Effekten
   kleben (dieselbe Mechanik wie in arthene-motion.js).

   Porträt: hängt (sticky) neben der Textspalte und ist nur da,
   solange „sein" Absatz im Bild steht — ab 1080px, denn darunter
   steht es über dem Text und blendet sich einmalig ein wie jeder
   andere Absatz auch.
   ============================================================ */
(function () {
  'use strict';

  var VERZUG_SCHRITT = 90;    /* Versatz je Element */
  var VERZUG_MAX = 450;       /* gedeckelt, sonst wartet man auf das letzte */
  var RV_DAUER = 1000;        /* Laufzeit aus dem CSS + Puffer */
  var NEBENAN = '(min-width: 1080px)';   /* ab hier steht das Porträt daneben */

  function ruhig() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* --- Reveals ------------------------------------------------ */

  function aufdecken(el) {
    el.classList.add('in');
    var verzug = parseFloat(el.style.getPropertyValue('--rd')) || 0;
    window.setTimeout(function () {
      el.classList.remove('rv');
      el.classList.remove('in');
      el.style.removeProperty('--rd');
    }, verzug + RV_DAUER);
  }

  /* staffeln: nur für Elemente, die als Gruppe ins Bild kommen (Standort).
     Die Absätze des Fließtextes stehen weit auseinander und werden einzeln
     aufgedeckt — ein Versatz wäre dort nur eine Verzögerung. */
  function revealsSetzen(io, elemente, staffeln) {
    var i = 0;
    Array.prototype.forEach.call(elemente, function (el) {
      if (!el) return;
      /* .ist-still nur für diesen einen Moment: sonst blendet ein Element,
         das beim Laden schon sichtbar war, erst einmal sichtbar weg, bevor
         es wieder hereinkommt. Weggeräumt wird die Klasse in init(). */
      el.classList.add('rv', 'ist-still');
      if (staffeln) {
        el.style.setProperty('--rd', Math.min(i++ * VERZUG_SCHRITT, VERZUG_MAX) + 'ms');
      }
      io.observe(el);
    });
  }

  /* --- Porträt ------------------------------------------------ */

  function portraetBinden(essay, portraet) {
    var nummer = parseInt(essay.getAttribute('data-arthene-portraet-absatz'), 10) || 1;
    var absaetze = essay.querySelectorAll('.essay__text > p');
    var anker = absaetze[nummer - 1] || absaetze[0];
    if (!anker) return false;

    portraet.classList.add('ist-gebunden');

    /* Unten großzügig zurückgenommen: das Porträt kommt erst, wenn der
       Absatz wirklich zum Lesen dasteht — nicht schon beim Anschneiden
       am unteren Rand. Oben ohne Rand, damit es bis zuletzt hängt. */
    var io = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          portraet.classList.toggle('ist-da', e.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px 0px -22% 0px' }
    );
    io.observe(anker);
    return true;
  }

  /* --- Aufbau -------------------------------------------------- */

  function nebenan() {
    return !window.matchMedia || window.matchMedia(NEBENAN).matches;
  }

  function init() {
    if (typeof IntersectionObserver !== 'function' || ruhig()) return;

    var essay = document.querySelector('[data-arthene-essay]');
    var portraet = essay && essay.querySelector('[data-arthene-portraet]');

    /* Gebunden wird immer — ob die Bindung auch sichtbar wird, entscheidet
       das CSS: unter 1080px steht das Porträt über dem Text und bleibt
       stehen, statt mit „seinem" Absatz zu kommen und zu gehen. */
    if (essay && portraet) portraetBinden(essay, portraet);

    var io = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) return;
          aufdecken(e.target);
          io.unobserve(e.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    if (essay) {
      /* Gestapelt zählt das Porträt als erstes „Absatz"-Element; daneben
         übernimmt die Bindung, und der Reveal wäre eine Blende zu viel. */
      if (portraet && !nebenan()) revealsSetzen(io, [portraet]);
      revealsSetzen(io, essay.querySelectorAll('.essay__text > *'));
    }

    var standort = document.querySelector('.standort');
    if (standort) {
      revealsSetzen(io, standort.querySelectorAll('.standort__adresse > *'), true);
    }

    /* Ein Umbruch, dann sind die Ausgangswerte gesetzt und die Übergänge
       dürfen wieder greifen. */
    void document.body.offsetHeight;
    Array.prototype.forEach.call(document.querySelectorAll('.rv.ist-still'), function (el) {
      el.classList.remove('ist-still');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   4. Die Anfahrt — die Kamerafahrt auf das erste Bild

   Die Fahrt selbst steht in arthene-ueber-uns.css (Abschnitt
   „Die Anfahrt"). Hier passieren nur zwei Dinge:

     a) MESSEN. Die Staffelei sitzt in einem Raster; ihre Endlage
        ist nicht in Viewport-Einheiten ausdrückbar. Also wird sie
        einmal ausgemessen und die Fahrt in Variablen abgelegt:
        wohin der Pigmentpunkt am Anfang geschoben werden muss
        (--f0x/--f0y), wohin die Mitte der Malfläche an Station 2
        (--f2x/--f2y), wo der Drehpunkt liegt (--fahrt-ox/-oy)
        und wie groß der Passepartout-Ausschnitt ist.

     b) FAHREN. Kann der Browser Scroll-Zeitachsen, fährt er selbst:
        Die Fahrstrecke ist die Zeitachse (.ist-zeitachse im CSS), das
        Skript setzt danach nur noch die Stationsmarken. Sonst stellt
        es pro Bild die Uhr der Animationen auf die Scrollposition
        (0 bis 1). Kein Scroll-Hijacking, die Scrollleiste bleibt echt.

   Geschaltet wird die Fahrt nur, wenn sie auch trägt: kein
   „Bewegung reduzieren" und ein Schirm, auf dem das zweispaltige
   Endbild überhaupt steht. Sonst — und ohne JavaScript — bleibt
   das erste Bild genau das, was es vorher war.
   ============================================================ */
(function () {
  'use strict';

  /* Feste Punkte im Bild assets/arthene-staffelei.webp (1100 × 2253),
     als Anteil an Breite und Höhe. Ausgemessen am Bild:
       Malfläche  x 17…1081, y 163…1440 (unten schneidet die Ablage
                  der Staffelei ab — sie gehört nicht ins Passepartout)
       Pigment    x 918, y 700 — im roten Malgrund rechts neben der
                  Schulter, freie Fläche mit sichtbarem Pinselzug
     Ein anderes Staffelei-Bild heißt: diese sechs Zahlen neu messen. */

  /* Drehpunkt der Fahrt und zugleich das, was am Anfang im Ausschnitt
     steht. Bewusst KEIN Gesichtsteil: ein Ausschnitt mit Nase und Augen
     liest sich als angeschnittenes Porträt, ein Stück Malgrund als das,
     was es ist — Farbe auf Leinwand. Von dort tritt die Kamera zurück.

     Der Punkt darf nicht zu weit nach rechts wandern: er läuft während der
     Fahrt zur Bildmitte, und läge er zu nah am Rand der Malfläche, käme
     dieser Rand unterwegs im Ausschnitt zum Vorschein. Die Grenze liegt
     bei x ≈ 0,87 — Abstand zum rechten Rand ≥ STATION_2 / (Anfangsmaßstab
     − STATION_2) × Abstand zur Bildmitte. */
  var PIGMENT_X = 0.8345, PIGMENT_Y = 0.3107;
  var LEIN_X = 0.4991, LEIN_Y = 0.3558;   /* Mitte der Malfläche */
  var LEIN_B = 0.9673, LEIN_H = 0.5668;   /* Malfläche: Anteil an Bildbreite/-höhe */

  /* Maßstab an Station 2. Größer geht nicht: bei 1,07 stößt die Staffelei
     oben und unten an die Bühne, und ihre Füße würden im selben Moment
     abgeschnitten, in dem der Karton sie freigibt.
     Muss mit dem Wert in den Keyframes übereinstimmen. */
  var STATION_2 = 1.06;

  /* Wie schmal darf der Schirm sein?

     Bis 2026-09-05 stand hier (min-width: 861px) — die Grenze, ab der
     Schriftzug und Staffelei nebeneinander stehen. Die Begründung war,
     gestapelt passe beides nicht mehr auf einen Schirm. Das stimmte,
     solange die Staffelei ihre Breite ohne den Schriftzug über sich
     rechnete; seit sie ihn in arthene-ueber-uns.css abzieht, geht die
     Rechnung auch auf dem Handy auf (nachgerechnet: 390 × 844 und
     375 × 667 füllen die Bühne genau).

     Es bleibt eine Höhengrenze: quer gehaltene Telefone sind rund
     390 px hoch, dort wäre die Staffelei ein Streichholz. 560 px lässt
     jedes hochkant gehaltene Gerät durch und hält das Querformat
     draußen. Die Breitengrenze verhindert nur Unfug bei sehr schmalen
     eingebetteten Fenstern. */
  var TRAEGT = '(min-width: 360px) and (min-height: 560px)';

  /* Kann der Browser die Fahrt selbst an die Scrollposition hängen?
     (Scroll-Zeitachse, siehe „Der Antrieb" in arthene-ueber-uns.css.)
     Dann rechnet er sie neben dem Scrollen her, und dieses Skript misst
     nur noch einmal aus. Sonst stellt es pro Bild die Uhr der Animationen. */
  var ZEITACHSE = !!(window.CSS && CSS.supports &&
                     CSS.supports('view-timeline', '--fahrt block') &&
                     CSS.supports('animation-timeline', '--fahrt') &&
                     CSS.supports('animation-range', 'contain 0% contain 100%'));

  /* Alles, was an der Fahrt hängt — dieselbe Liste wie im CSS. */
  var BEWEGT = '.staffelei, .werkschild, .rundgang__title, .anfahrt__blatt,' +
               ' .anfahrt__mat, .anfahrt__korn, .anfahrt__katalog,' +
               ' .anfahrt__hinweis, .anfahrt__fuellung';

  var sec, weg, stage, fig, img, marken;
  var aktiv = false;
  /* Lage der Fahrstrecke im Dokument, einmal gemessen: Pro Bild wird
     daraus nur noch gerechnet, nicht gemessen. */
  var wegOben = 0, fahrStrecke = 0;
  var animationen = [];
  var station = -1;
  var letzteB = -1, letzteH = -1;

  function ruhig() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function setzen(name, px) {
    sec.style.setProperty(name, Math.round(px * 100) / 100 + 'px');
  }

  /* --- a) Messen ---------------------------------------------- */

  function messen() {
    /* Ohne transform lesen: die Keyframes stehen sonst im Weg. Das
       passiert in einem Rechenschritt, dazwischen wird nichts gemalt. */
    sec.classList.add('ist-messen');
    var sr = stage.getBoundingClientRect();
    var fr = fig.getBoundingClientRect();
    var ir = img.getBoundingClientRect();
    var cs = window.getComputedStyle(stage);
    var oben = parseFloat(cs.paddingTop) || 0;
    var unten = parseFloat(cs.paddingBottom) || 0;
    sec.classList.remove('ist-messen');

    if (!ir.width || !ir.height) return false;

    /* Drehpunkt: der Pigmentpunkt, gerechnet im Kasten der Figur —
       transform-origin bezieht sich auf sie, nicht auf das Bild. */
    setzen('--fahrt-ox', ir.left - fr.left + PIGMENT_X * ir.width);
    setzen('--fahrt-oy', ir.top - fr.top + PIGMENT_Y * ir.height);

    /* Pigmentpunkt und Mitte der Malfläche in Bühnenkoordinaten. */
    var pigX = ir.left - sr.left + PIGMENT_X * ir.width;
    var pigY = ir.top - sr.top + PIGMENT_Y * ir.height;
    var leinX = ir.left - sr.left + LEIN_X * ir.width;
    var leinY = ir.top - sr.top + LEIN_Y * ir.height;

    /* Ziel ist die Mitte des Inhaltskastens — dieselbe Achse, auf der
       das Raster die Endstation zentriert. */
    var mitteX = sr.width / 2;
    var mitteY = oben + (sr.height - oben - unten) / 2;

    /* Station 2: die GANZE Staffelei steht mittig auf der Bühne — nicht
       die Malfläche. Zentrierte man die, stünden die Füße der Staffelei
       unter dem Bühnenrand und wären genau in dem Moment abgeschnitten,
       in dem der Karton sie freigibt.
       Punkte wandern mit dem Maßstab um den Drehpunkt: erst skalieren,
       dann die Differenz nehmen. */
    var bildX = ir.left - sr.left + 0.5 * ir.width;
    var bildY = ir.top - sr.top + 0.5 * ir.height;
    var f2x = mitteX - (pigX + STATION_2 * (bildX - pigX));
    var f2y = mitteY - (pigY + STATION_2 * (bildY - pigY));
    setzen('--f2x', f2x);
    setzen('--f2y', f2y);

    /* Der Ausschnitt liegt dort, wo die Malfläche an Station 2 steht, und
       hat genau ihr Maß: dort decken sich Bild und Passepartout. Weil die
       Staffelei mittig steht, sitzt er etwas über der Bühnenmitte — darunter
       bleibt Platz für die Katalogzeile. */
    var matX = pigX + STATION_2 * (leinX - pigX) + f2x;
    var matY = pigY + STATION_2 * (leinY - pigY) + f2y;
    setzen('--fahrt-mx', matX);
    setzen('--fahrt-my', matY);
    setzen('--fahrt-matw', LEIN_B * ir.width * STATION_2);
    setzen('--fahrt-math', LEIN_H * ir.height * STATION_2);

    /* Station 1: der Pigmentpunkt steht in der Mitte des Ausschnitts. Weil
       er zugleich der Drehpunkt ist, bleibt er dort, egal wie groß der
       Maßstab ist. */
    setzen('--f0x', matX - pigX);
    setzen('--f0y', matY - pigY);

    fahrStrecke = weg.offsetHeight - stage.offsetHeight;
    wegOben = weg.getBoundingClientRect().top + window.pageYOffset;

    /* .ist-messen hat die Animation der Staffelei kurz abgeschaltet —
       danach ist es eine neue. Die Uhren also frisch einsammeln. */
    if (!ZEITACHSE) animationenHolen();

    return true;
  }

  function animationenHolen() {
    animationen = [];
    if (typeof sec.getAnimations !== 'function') return;
    Array.prototype.forEach.call(sec.querySelectorAll(BEWEGT), function (el) {
      el.getAnimations().forEach(function (a) { animationen.push(a); });
    });
  }

  /* --- b) Fahren ---------------------------------------------- */

  /* Nur wenn die Station wechselt — nicht in jedem Bild drei Knöpfe
     umschreiben. */
  function markenSetzen(p) {
    var da = p < 0.3 ? 0 : (p < 0.8 ? 1 : 2);
    if (da === station) return;
    station = da;
    for (var i = 0; i < marken.length; i++) {
      marken[i].classList.toggle('ist-da', i === da);
      if (i === da) marken[i].setAttribute('aria-current', 'true');
      else marken[i].removeAttribute('aria-current');
    }
  }

  /* Reine Rechnung aus der Scrollposition — kein Messen pro Bild. */
  function fortschritt() {
    if (fahrStrecke <= 0) return 1;
    var p = (window.pageYOffset - wegOben) / fahrStrecke;
    return p < 0 ? 0 : p > 1 ? 1 : p;
  }

  function fahren() {
    if (!aktiv) return;
    var p = fortschritt();
    if (!ZEITACHSE) {
      if (animationen.length) {
        /* Die Uhr jeder Animation direkt stellen: berührt nur das eine
           Element, nicht den Stil der ganzen Section. */
        var t = p * 1000;
        for (var i = 0; i < animationen.length; i++) animationen[i].currentTime = t;
      } else {
        sec.style.setProperty('--p', p.toFixed(4));   /* letztes Netz */
      }
    }
    markenSetzen(p);
  }

  var wartet = false;
  function anstossen() {
    if (wartet) return;
    wartet = true;
    window.requestAnimationFrame(function () {
      wartet = false;
      fahren();
    });
  }

  /* --- An und aus ---------------------------------------------- */

  function pruefen() {
    var soll = !ruhig() && (!window.matchMedia || window.matchMedia(TRAEGT).matches);

    if (soll && !aktiv) {
      sec.classList.add('ist-fahrt');
      if (ZEITACHSE) sec.classList.add('ist-zeitachse');
      aktiv = true;
      station = -1;
      if (!messen()) {           /* Bild noch ohne Maße — später nochmal */
        sec.classList.remove('ist-fahrt', 'ist-zeitachse');
        aktiv = false;
        return;
      }
      fahren();
    } else if (!soll && aktiv) {
      sec.classList.remove('ist-fahrt', 'ist-zeitachse');
      sec.style.removeProperty('--p');
      animationen = [];
      aktiv = false;
    } else if (aktiv) {
      messen();
      fahren();
    }
  }

  function init() {
    sec = document.querySelector('[data-arthene-fahrt]');
    if (!sec) return;
    weg = sec.querySelector('[data-arthene-weg]');
    stage = sec.querySelector('[data-arthene-rundgang-stage]');
    fig = sec.querySelector('.staffelei');
    img = fig && fig.querySelector('img');
    if (!weg || !stage || !fig || !img) return;

    marken = [].slice.call(sec.querySelectorAll('[data-fahrt-ziel]'));
    marken.forEach(function (m) {
      m.addEventListener('click', function () {
        var ziel = parseFloat(m.getAttribute('data-fahrt-ziel')) || 0;
        if (fahrStrecke <= 0) return;
        window.scrollTo({ top: Math.round(wegOben + ziel * fahrStrecke), behavior: 'smooth' });
      });
    });

    pruefen();

    window.addEventListener('scroll', anstossen, { passive: true });
    /* Auf dem iPhone feuert resize auch, wenn beim Scrollen die
       Adressleiste ein- oder ausfährt. Die Bühne rechnet in svh, ändert
       sich dabei also nicht — neu gemessen wird nur bei echter
       Größenänderung (Breite, oder Höhe um mehr als eine Leiste). */
    window.addEventListener('resize', function () {
      var b = window.innerWidth, h = window.innerHeight;
      if (b === letzteB && Math.abs(h - letzteH) < 150) return;
      letzteB = b; letzteH = h;
      pruefen();
    });
    letzteB = window.innerWidth; letzteH = window.innerHeight;
    /* Ändert sich die Bühne trotzdem (Schriften, Bilder, Fenster), merkt
       das der Beobachter — ohne dass jemand pro Bild nachmisst. */
    if (typeof ResizeObserver === 'function') {
      var erstesMal = true;
      new ResizeObserver(function () {
        if (erstesMal) { erstesMal = false; return; }
        pruefen();
      }).observe(stage);
    }
    /* Schriften und das Staffelei-Bild ändern die Maße noch nach. */
    window.addEventListener('load', pruefen);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(pruefen);
    if (!img.complete) img.addEventListener('load', pruefen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme-Editor: nach dem Neuladen der Section neu aufsetzen. */
  document.addEventListener('shopify:section:load', function () {
    aktiv = false;
    init();
  });
})();

/* ============================================================
   5. Die Wanderung: die Leinwand verlässt das Kopfbild

   Wenn die Anfahrt angekommen ist und der Text von unten nachrückt,
   wird die Malfläche an den Porträtplatz getragen. Getragen wird nur
   sie: Dafür liegt ein Kasten auf der Seite (.flug), der das
   Staffelei-Bild so beschnitten zeigt, dass nur die Leinwand darin
   steht (Zuschnitt im CSS).

     Start  genau auf der Malfläche im Kopfbild — deckungsgleich,
            deshalb sieht man das Abheben nicht als Sprung
     Ziel   der leere Kasten im Porträtplatz (.portraet__ziel)
     dazwischen ein Bogen: angehoben, leicht gedreht, mit
            wachsendem Schatten — getragen, nicht geschoben

   Wie es flüssig bleibt:

     - Start und Ziel werden EINMAL im Dokument vermessen (und wieder,
       wenn sich die Seite ändert), nicht in jedem Bild. Pro Bild gibt
       es nur noch Rechnung aus der Scrollposition und eine Transform.
       Vorher las das Skript in jedem Bild zwei Rechtecke, unmittelbar
       nachdem es Variablen an zwei ganze Abschnitte geschrieben hatte —
       das erzwang jedes Mal eine komplette Neuberechnung.

     - Der Kasten liegt im Dokument (position:absolute), nicht fest im
       Schirm. Start und Ziel scrollen mit dem Text, also scrollt er mit
       — der Browser schiebt ihn, nicht das Skript. Das Skript bestimmt
       nur, wie weit die Wanderung ist.

     - Angekommen übergibt der Kasten an den Zielplatz: dort steht dann
       derselbe Zuschnitt als eigenes Bild und klebt bzw. scrollt mit der
       Spalte. Vorher blieb der Kasten stehen und wurde dem Ziel Bild für
       Bild hinterhergerechnet — auf dem Telefon hing er sichtbar nach.

   Der Fortschritt hängt am Zielplatz: 0, solange er weiter als der
   Reiseweg von seinem Ruheplatz entfernt ist, 1, sobald er dort ist —
   auf dem Desktop also genau dann, wenn die Spalte zu kleben beginnt.

   Geschaltet wie die Anfahrt und ohne „Bewegung reduzieren" — sonst
   steht das Porträt an seinem Platz wie bisher.
   ============================================================ */
(function () {
  'use strict';

  /* Die Wanderung hängt an der Anfahrt: wo die Kamerafahrt läuft, soll
     die Leinwand danach auch weiterwandern — sonst bliebe sie mitten im
     Bild stehen. Deshalb dieselbe Grenze wie dort (TRAEGT in Abschnitt 4).

     Zwischen 760 und 1080px steht das Ziel nicht neben dem Text, sondern
     darüber — getragen wird trotzdem, nur eben an den Platz über dem
     ersten Absatz. Auf dem Handy ist es derselbe Platz, nur schmaler.

     Was sich gestapelt anders verhält, ist das Kopfbild: dort bleibt die
     Staffelei stehen und nur die Malfläche wird leer, statt dass das
     ganze Bild wegblendet — die Begründung steht in arthene-ueber-uns.css
     bei „Die Staffelei bleibt zurück". */
  var NEBENAN = '(min-width: 360px) and (min-height: 560px)';

  /* Lage der Malfläche im Bild — dieselben Anteile wie im CSS.
     Die Höhe steckt dort im Seitenverhältnis des Kastens. */
  var LEIN_X = 0.02818, LEIN_Y = 0.07235, LEIN_B = 0.94818;

  /* Reiseweg in Bildschirmhöhen: so lange vor dem Ruheplatz beginnt
     die Wanderung. Kürzer wirkt sie hektisch, länger fängt sie an,
     während das Kopfbild noch ganz im Schirm steht. */
  var WEG = 0.8;

  var essay, spalte, portraet, figur, ziel, zeile, heroBild, staffelei, rundgang, weg, stage;
  var flug = null, zielFenster = null;
  var aktiv = false, geplant = false, sichtbar = true;
  var ruhe = 0, strecke = 240, klebtZiel = false;
  /* Scrollposition, an der sich die Bühne der Anfahrt löst (null ohne
     Anfahrt) — dort beginnt die Wanderung. */
  var freigabe = null;
  /* Alles in Dokumentkoordinaten, gemessen in masseNehmen(). */
  var start = { x: 0, y: 0, b: 1 }, ende = { x: 0, y: 0, b: 1 };
  var ursprungX = 0, ursprungY = 0;
  var zustand = '', letzterWert = '';
  var schirmH = 0, schirmB = -1;

  /* Schirmhöhe, die beim Scrollen stillhält: Auf dem iPhone ändert sich
     window.innerHeight, sobald die Adressleiste ein- oder ausfährt — mitten
     im Scrollen. Ruheplatz und Reiseweg rechneten damit neu, und die
     Leinwand sprang im Flug. Neu genommen wird sie nur, wenn sich die
     Breite ändert oder die Höhe um mehr als eine Leiste. */
  function schirmHoehe() {
    var b = window.innerWidth, h = window.innerHeight;
    if (b !== schirmB || Math.abs(h - schirmH) > 150) {
      schirmB = b;
      schirmH = h;
    }
    return schirmH;
  }

  function klemme(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function ruhig() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  /* Weich anfahren, weich ankommen — das Werk soll getragen wirken.
     Gilt für alles, was nicht mitscrollt: Seitwärts, Größe, Drehung. */
  function sanft(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  /* Die SENKRECHTE braucht eine andere Kurve.

     Start und Ziel liegen im Dokument und scrollen mit. Was man sieht,
     ist deshalb nicht die Kurve selbst, sondern Kurve minus Scrollen.
     sanft() ist in der Mitte dreimal so schnell wie im Schnitt — auf dem
     Telefon (575 px Weg im Dokument auf 650 px Scrollweg) hieß das: die
     Leinwand fuhr erst mit der Seite hoch, schoss dann 190 px nach UNTEN
     und fuhr wieder hoch. Ein Jo-Jo statt eines Tragens.

     Hier läuft die Geschwindigkeit deshalb in drei Teilen: weich anheben,
     gleichmäßig tragen, weich absetzen (Anstieg und Abfall als halbe
     Kosinuswelle). Die Rampenlänge r wird aus dem Verhältnis von
     Dokumentweg zu Scrollweg so gewählt, dass die Leinwand im mittleren
     Teil auf dem Schirm still hängt, während der Text unter ihr
     durchzieht — sie läuft auf dem Schirm nie rückwärts. Die 10 % unten
     halten Abheben und Aufsetzen weich, auch wenn der Weg fast so lang
     ist wie das Scrollen. */
  /* klebt: Auf dem Desktop bleibt der Zielplatz nach der Landung stehen
     (die Spalte klebt) — dort darf die Leinwand am Ende nicht mehr mit der
     Seite hochfahren, sondern muss im Stillstand ankommen. Dann gibt es nur
     die Rampe am Anfang; der gleichmäßige Teil, in dem sie still hängt,
     geht direkt in den klebenden Platz über. */
  function tragen(p, verhaeltnis, klebt) {
    var r = klebt ? 2 * (1 - verhaeltnis) : 1 - verhaeltnis;
    r = r < 0.1 ? 0.1 : r > 0.45 ? 0.45 : r;
    var h = klebt ? 1 / (1 - r / 2) : 1 / (1 - r);   /* Höhe des gleichmäßigen Teils */
    function rampe(t) { return h / 2 * (t - r / Math.PI * Math.sin(Math.PI * t / r)); }
    if (p <= r) return rampe(p);
    if (!klebt && p >= 1 - r) return 1 - rampe(1 - p);
    return h * r / 2 + h * (p - r);
  }

  /* --- Vermessen ----------------------------------------------- */

  /* Die Malfläche so, wie sie am ENDE der Anfahrt steht: Die Bühne sitzt
     dann am Fuß der Fahrstrecke, und die Staffelei trägt keine Transform
     mehr. Gemessen über offsetLeft/offsetTop bis zur Bühne — die kennen
     keine Transform, die Kamerafahrt stört also nicht, egal wo man
     gerade steht. Ohne Anfahrt liegt das Bild einfach im Fluss. */
  function startMessen() {
    var b = heroBild.offsetWidth, h = heroBild.offsetHeight;
    var x = null, y = null;
    if (rundgang.classList.contains('ist-fahrt') && weg && stage) {
      var ox = 0, oy = 0, el = heroBild;
      while (el && el !== stage) { ox += el.offsetLeft; oy += el.offsetTop; el = el.offsetParent; }
      if (el === stage) {
        var wr = weg.getBoundingClientRect();
        x = stage.getBoundingClientRect().left + window.pageXOffset + ox;
        freigabe = wr.top + window.pageYOffset + weg.offsetHeight - stage.offsetHeight;
        y = freigabe + oy;
      }
    }
    if (x === null) {
      var r = heroBild.getBoundingClientRect();
      x = r.left + window.pageXOffset;
      y = r.top + window.pageYOffset;
      b = r.width; h = r.height;
    }
    start.x = x + LEIN_X * b;
    start.y = y + LEIN_Y * h;
    start.b = Math.max(1, LEIN_B * b);
  }

  /* Der Zielplatz in seiner Lage im Fluss — dort, wo die Spalte ihn hält,
     sobald sie klebt. Gemessen über die Spalte, die selbst nicht klebt:
     Der Abstand Ziel–Figur ist von sticky unberührt, und die Figur steht
     oben in der Spalte. */
  function zielMessen(klebt) {
    var sp = spalte.getBoundingClientRect();
    var fr = figur.getBoundingClientRect();
    var zr = ziel.getBoundingClientRect();
    var figurOben = klebt ? 0 : fr.top - sp.top;
    ende.x = zr.left + window.pageXOffset;
    ende.y = sp.top + figurOben + (zr.top - fr.top) + window.pageYOffset;
    ende.b = Math.max(1, zr.width);
  }

  function masseNehmen() {
    if (!aktiv || !flug) return;
    var h = schirmHoehe();
    /* Der Ruheplatz ist der Anschlag der klebenden Spalte. Steht die
       Spalte nicht (gestapeltes Layout, dort ist top:auto), gibt es
       keinen Anschlag: dann kommt das Werk auf gut einem Fünftel der
       Schirmhöhe an — hoch genug, um es ankommen zu sehen, bevor es mit
       dem Text weiterzieht. */
    var t = parseFloat(window.getComputedStyle(figur).top);
    var klebt = isFinite(t);
    klebtZiel = klebt;
    ruhe = klebt ? t : h * 0.22;

    freigabe = null;
    startMessen();
    zielMessen(klebt);

    /* Die Wanderung beginnt dort, wo die Anfahrt endet: Die Bühne löst
       sich, die Leinwand steht vollständig im Bild. Vorher hing der Start
       an einem festen Bruchteil der Schirmhöhe — am Desktop war die
       Leinwand dann schon halb oben aus dem Bild, bevor sie losflog.
       Ohne Anfahrt gilt der feste Reiseweg wie bisher. Unter 240 px
       Scrollweg wird es hektisch, dann beginnt sie entsprechend früher. */
    var landung = ende.y - ruhe;
    var ab = freigabe !== null ? freigabe : landung - h * WEG;
    strecke = Math.max(240, landung - ab);

    /* Wo läge der Kasten ohne Verschiebung? Meist im Ursprung des
       Dokuments — gemessen, damit es auch stimmt, wenn nicht. */
    flug.style.transform = 'none';
    flug.style.width = start.b.toFixed(1) + 'px';
    var o = flug.getBoundingClientRect();
    ursprungX = o.left + window.pageXOffset;
    ursprungY = o.top + window.pageYOffset;

    zustand = '';           /* nach dem Vermessen einmal frisch setzen */
    letzterWert = '';
  }

  /* --- Bauen ---------------------------------------------------- */

  /* Drei Ebenen, nicht zwei: außen der Kasten mit Lage, Drehung und
     Schatten, darin ein Fenster, das den Zuschnitt macht, und darin das
     Bild. Das Fenster ist der Grund, warum auf iOS überhaupt nur die
     Malfläche zu sehen ist: Safari schneidet mit overflow:hidden nicht
     zuverlässig zu, wenn das Element selbst transformiert wird — dann
     hing die ganze Staffelei am Gemälde und wanderte mit in den Text.
     Das Fenster trägt keine eigene Transformation und zusätzlich
     clip-path, das immer schneidet. */
  function fenster() {
    var f = document.createElement('span');
    f.className = 'flug__fenster';
    var b = document.createElement('img');
    b.src = heroBild.currentSrc || heroBild.src;
    b.alt = '';
    b.decoding = 'async';
    f.appendChild(b);
    return f;
  }

  function bauen() {
    flug = document.createElement('div');
    flug.className = 'flug';
    flug.setAttribute('aria-hidden', 'true');
    flug.appendChild(fenster());
    document.body.appendChild(flug);
    /* Derselbe Zuschnitt noch einmal im Zielplatz — er übernimmt bei
       der Landung (s. CSS „Der Zielplatz"). */
    zielFenster = fenster();
    ziel.appendChild(zielFenster);
  }

  function abbauen() {
    if (flug && flug.parentNode) flug.parentNode.removeChild(flug);
    if (zielFenster && zielFenster.parentNode) zielFenster.parentNode.removeChild(zielFenster);
    flug = zielFenster = null;
    zustand = letzterWert = '';
    if (rundgang) rundgang.classList.remove('hat-wanderung');
    if (portraet) portraet.classList.remove('hat-wanderung');
    if (ziel) ziel.classList.remove('ist-belegt');
    if (staffelei) staffelei.style.removeProperty('--flug');
    if (zeile) zeile.style.removeProperty('--flug');
  }

  /* --- Pro Bild: nur rechnen und schreiben ---------------------- */

  /* Beide Wechsel ohne Blende: Beim Abheben liegt der Kasten genau auf
     der Leinwand der Staffelei, bei der Landung genau auf dem Zielplatz —
     der Tausch ist dort jeweils unsichtbar. Eine zeitliche Blende (vorher
     0,6 s beim Abheben) lief dagegen neben dem Scrollen her: wer schnell
     scrollte, sah kurz zwei halbdurchsichtige Bilder übereinander. */
  function zustandSetzen(neu) {
    if (neu === zustand) return;
    flug.classList.toggle('ist-sichtbar', neu === 'flug');
    ziel.classList.toggle('ist-belegt', neu === 'da');
    zustand = neu;
  }

  function rechnen() {
    geplant = false;
    if (!aktiv || !flug) return;

    var p = klemme(1 - (ende.y - window.pageYOffset - ruhe) / strecke);

    zustandSetzen(p <= 0.001 ? 'ruhe' : (p >= 0.999 ? 'da' : 'flug'));

    /* --flug liest nur die Staffelei (die Malfläche wird leer bzw. das
       Kopfbild verblasst) und die Namenszeile unter dem Ziel. Die Zahl
       steht deshalb genau dort — nicht an ganzen Abschnitten, deren
       sämtliche Kinder sonst in jedem Bild neu berechnet würden. */
    var wert = p.toFixed(3);
    if (wert !== letzterWert) {
      letzterWert = wert;
      staffelei.style.setProperty('--flug', wert);
      if (zeile) zeile.style.setProperty('--flug', wert);
    }

    if (zustand !== 'flug') return;

    var e = sanft(p);
    var bogen = Math.sin(Math.PI * e);
    var ey = tragen(p, (ende.y - start.y) / strecke, klebtZiel);
    var x = start.x + (ende.x - start.x) * e - ursprungX;
    var y = start.y + (ende.y - start.y) * ey - bogen * 26 - ursprungY;
    var s = 1 + (ende.b / start.b - 1) * e;

    /* translate statt translate3d: die 3D-Variante öffnet in Safari einen
       3D-Kontext, in dem das Fenster darunter nicht mehr zuverlässig
       schneidet (s. fenster()). Auf den Compositor kommt der Kasten auch
       so — dafür steht will-change im CSS. */
    flug.style.transform =
      'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)' +
      ' rotate(' + (-bogen * 1.1).toFixed(2) + 'deg)' +
      ' scale(' + s.toFixed(4) + ')';
    flug.style.setProperty('--bogen', bogen.toFixed(3));
    /* Der ruhende Schatten wächst beim Abheben mit (s. .flug::after). */
    flug.style.setProperty('--auf', Math.min(1, p / 0.12).toFixed(3));
  }

  function anfordern() {
    if (geplant || !aktiv) return;
    geplant = true;
    requestAnimationFrame(rechnen);
  }

  /* --- An und aus ---------------------------------------------- */

  function pruefen() {
    var soll = !!(essay && ziel && heroBild) &&
               (!window.matchMedia || window.matchMedia(NEBENAN).matches) &&
               !ruhig();
    if (soll === aktiv) { if (aktiv) { masseNehmen(); anfordern(); } return; }
    aktiv = soll;
    if (!aktiv) { abbauen(); return; }

    rundgang.classList.add('hat-wanderung');
    portraet.classList.add('hat-wanderung');
    /* Gestapelt hat Abschnitt 2 den Porträtplatz als Reveal angemeldet
       (.rv: tiefer gesetzt, unscharf). Mit Wanderung wird das Werk aber
       hergetragen — der Platz darf dann nicht selbst noch hereinrutschen,
       sonst verschiebt er sich unter dem ankommenden Werk. */
    portraet.classList.remove('rv', 'in', 'ist-still');
    portraet.style.removeProperty('--rd');
    bauen();
    masseNehmen();
    anfordern();
  }

  /* Vermessen nur, wenn sich wirklich etwas geändert hat — gesammelt auf
     ein Bild, damit mehrere Anlässe kurz nacheinander nur einmal messen. */
  var messenGeplant = false;
  function neuMessen() {
    if (messenGeplant) return;
    messenGeplant = true;
    requestAnimationFrame(function () {
      messenGeplant = false;
      if (aktiv) { masseNehmen(); rechnen(); }
    });
  }

  function init() {
    essay = document.querySelector('[data-arthene-wanderung]');
    if (!essay) return;
    portraet = essay.querySelector('[data-arthene-portraet]');
    spalte = portraet;
    figur = portraet && portraet.querySelector('.portraet');
    ziel = essay.querySelector('[data-arthene-ziel]');
    zeile = portraet && portraet.querySelector('.portraet__zeile');
    rundgang = document.querySelector('[data-arthene-rundgang]');
    weg = rundgang && rundgang.querySelector('[data-arthene-weg]');
    stage = rundgang && rundgang.querySelector('[data-arthene-rundgang-stage]');
    staffelei = rundgang && rundgang.querySelector('.staffelei');
    heroBild = staffelei && staffelei.querySelector('img');
    if (!portraet || !figur || !ziel || !heroBild) return;

    /* Nur rechnen, wenn der Text auch in der Nähe ist. Der großzügige
       Rand hält den Kasten über den ganzen Anflug hinweg aktuell. */
    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (eintraege) {
        sichtbar = eintraege[0].isIntersecting;
        anfordern();
      }, { rootMargin: '100% 0px 100% 0px' }).observe(essay);
    }

    window.addEventListener('scroll', function () { if (sichtbar) anfordern(); }, { passive: true });
    /* resize feuert auf dem iPhone auch beim Ein- und Ausfahren der
       Adressleiste; schirmHoehe() fängt das ab, gemessen wird trotzdem
       nur gesammelt. */
    window.addEventListener('resize', pruefen, { passive: true });
    window.addEventListener('load', neuMessen);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(neuMessen);
    if (!heroBild.complete) heroBild.addEventListener('load', neuMessen);
    /* Wächst oder schrumpft die Seite (Bilder, Schriften, aufgeklappte
       Inhalte), verschieben sich Start und Ziel — dann neu vermessen. */
    if (typeof ResizeObserver === 'function') {
      var erstesMal = true;
      new ResizeObserver(function () {
        if (erstesMal) { erstesMal = false; return; }
        neuMessen();
      }).observe(document.body);
    }

    pruefen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme-Editor: nach dem Neuladen der Section neu aufsetzen. */
  document.addEventListener('shopify:section:load', function () {
    abbauen();
    aktiv = false;
    init();
  });
})();
